import React, { useState } from "react";
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { Dropdown, PrimaryButton, TextField, ActionButton } from '@fluentui/react';

const dropdownContainerCss = css`
    display: flex; 
    align-items: flex-end; 
    .edit-text-field { width: 100%; }
`;

const DropdownTextToggle = ({ options, selectedCategory, disabled, copy, isNew, addChange, editChange, rootCss }) => {
    const [selectedItem, setSelectedItem] = useState(selectedCategory);
    const [isAddMode, setIsAddMode] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [newItemName, setNewItemName] = useState('');
    const editIcon = { iconName: 'Edit' };
  
    const handleOptionToggle = () => {
        setNewItemName('');
        setIsAddMode((prevIsAddMode) => !prevIsAddMode);
    }

    const handleEditToggle = () => {
        setNewItemName(selectedItem.text);
        setIsEditMode(true);
    }

    const handleCancelToggle = (e) => {
        setNewItemName('');
        addChange(e, selectedItem);
        setIsEditMode(false);
    }

    const handleAdd = (e, value) => {
        addChange(e, value);
        isAddMode ? setNewItemName(value) : setSelectedItem(value);
    }

    const handleEdit = (e, value) => {
        editChange(e, value);
        isEditMode ? setNewItemName(value) : setSelectedItem(value);
    }
  
    return (
        <div css={rootCss}>
        {isAddMode ? (
            <TextField
                className="add-text-field"
                name={copy.name}
                label={copy.label}
                placeholder={copy.addPlaceholder}
                value={newItemName}
                onChange={handleAdd}
            />
            ) : (
            <div className="dropdown-container" css={dropdownContainerCss}>
                {isEditMode ? (
                <>
                    <TextField
                        className="edit-text-field"
                        name={copy.name}
                        label={copy.label}
                        value={newItemName}
                        onChange={handleEdit}
                    />
                    <ActionButton 
                        iconProps={editIcon} 
                        allowDisabledFocus 
                        disabled={disabled}
                        onClick={handleCancelToggle}
                    >
                        Cancel
                    </ActionButton>
                </>
                ) : (
                <>
                    <Dropdown
                        className="select-dropdown"
                        placeholder={copy.dropPlaceholder}
                        options={options}
                        selectedKey={selectedItem.key}
                        onChange={handleAdd}
                        label={copy.label}
                        disabled={disabled}
                    />
                    <ActionButton 
                        iconProps={editIcon} 
                        allowDisabledFocus isNew
                        disabled={disabled || !selectedItem.key}
                        onClick={handleEditToggle}
                    >
                        Edit
                    </ActionButton>
                </>
                )}
            </div>
        )}
            <PrimaryButton 
                className="toggle-button"
                text={isAddMode ? copy.btnText : copy.addBtnText} 
                onClick={handleOptionToggle} 
                disabled={disabled || isEditMode}
            />
        </div>
    );
};

export default DropdownTextToggle;
